var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotavatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "#057DCD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1202_3349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.96847 11.75C8.92383 11.577 8.83364 11.4191 8.70728 11.2927C8.58092 11.1663 8.42301 11.0761 8.24997 11.0315L5.18247 10.2405C5.13014 10.2256 5.08407 10.1941 5.05128 10.1507C5.01848 10.1073 5.00073 10.0544 5.00073 10C5.00073 9.9456 5.01848 9.89268 5.05128 9.84928C5.08407 9.80588 5.13014 9.77436 5.18247 9.7595L8.24997 8.968C8.42294 8.92341 8.58082 8.83329 8.70717 8.70702C8.83353 8.58075 8.92375 8.42295 8.96847 8.25L9.75947 5.1825C9.77417 5.12996 9.80566 5.08367 9.84913 5.0507C9.8926 5.01773 9.94566 4.99988 10.0002 4.99988C10.0548 4.99988 10.1078 5.01773 10.1513 5.0507C10.1948 5.08367 10.2263 5.12996 10.241 5.1825L11.0315 8.25C11.0761 8.42304 11.1663 8.58095 11.2927 8.70731C11.419 8.83367 11.5769 8.92386 11.75 8.9685L14.8175 9.759C14.8702 9.77355 14.9167 9.80501 14.9499 9.84854C14.983 9.89207 15.001 9.94528 15.001 10C15.001 10.0547 14.983 10.1079 14.9499 10.1515C14.9167 10.195 14.8702 10.2265 14.8175 10.241L11.75 11.0315C11.5769 11.0761 11.419 11.1663 11.2927 11.2927C11.1663 11.4191 11.0761 11.577 11.0315 11.75L10.2405 14.8175C10.2258 14.87 10.1943 14.9163 10.1508 14.9493C10.1073 14.9823 10.0543 15.0001 9.99972 15.0001C9.94516 15.0001 9.8921 14.9823 9.84863 14.9493C9.80516 14.9163 9.77367 14.87 9.75897 14.8175L8.96847 11.75Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5V7.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6.5H13",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5V13.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13H5.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_3349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotavatar);
export default __webpack_public_path__ + "static/media/botavatar.9c23a40fcec238cddfc4241deaf66260.svg";
export { ForwardRef as ReactComponent };